import { isString } from './string';

export const normalizeEmail = (email: string | null | undefined) =>
  !!email && isString(email) ? email.toLocaleLowerCase().trim() : '';
